import { CertificateModel, ExceptionModel, LacunaWebPKI } from "web-pki";
import {
  ITokenCertificate,
  IUserTokenCertificate
} from "@/store/types/signature-type";
import { IFunction } from "@/store/types/types";

export const pki =
  process.env.NODE_ENV !== "development"
    ? new LacunaWebPKI(process.env.VUE_APP_PKI_LICENSE)
    : new LacunaWebPKI();

export const pkiLogin =
  process.env.NODE_ENV !== "development"
    ? new LacunaWebPKI(process.env.VUE_APP_PKI_LICENSE_LOGIN)
    : new LacunaWebPKI();

type ReturnCert = (_: CertificateModel[]) => void;

const getCertificates = (onReady: ReturnCert, pkiInstance = pki) =>
  pkiInstance.listCertificates().success(certs => {
    onReady(certs);
  });

const onFail = (event: ExceptionModel) => alert(event.userMessage);

export const InitLogin = (
  onReady: ReturnCert = () => null,
  onNotInstalled: (_: typeof pki) => void
) =>
  pkiLogin.init({
    restPkiUrl: process.env.VUE_APP_PKI_URL_LOGIN,
    ready: () => getCertificates(onReady, pkiLogin),
    notInstalled: () => onNotInstalled(pkiLogin),
    defaultFail: onFail
  });

export const Init = (
  onReady = () => null,
  onNotInstalled: IFunction<typeof pki> = () => null
) =>
  pki.init({
    restPkiUrl: process.env.VUE_APP_PKI_URL,
    ready: () => getCertificates(onReady),
    notInstalled: () => onNotInstalled(pki),
    defaultFail: onFail
  });

export const SignDocuments = async (
  documentsTokens: ITokenCertificate[],
  callback: (_: ITokenCertificate[]) => void
) => {
  const signedDocuments: ITokenCertificate[] = [];

  await Promise.all(
    documentsTokens.map(
      (document: ITokenCertificate) =>
        new Promise((resolve, reject) =>
          pki
            .signWithRestPki(document)
            .success(() => {
              signedDocuments.push(document);
              resolve(document);
            })
            .fail(reject)
        )
    )
  ).then(() => {
    callback(signedDocuments);
  });
};

export const SingIn = async (
  userToken: IUserTokenCertificate,
  callback: (_: IUserTokenCertificate) => void
) => {
  pkiLogin.signWithRestPki(userToken).success(() => {
    callback(userToken);
  });
};
